import { Outlet } from 'react-router-dom';
import { OfflineBanner } from './offline-banner';
import { TopBar } from './top-bar';

export function AppShell() {
  return (
    <div className="flex min-h-screen flex-col">
      <TopBar />
      <OfflineBanner />
      <main className="mx-auto w-full max-w-[100rem] flex-1 px-4 py-6 sm:px-6 lg:px-8">
        <Outlet />
      </main>
    </div>
  );
}
